// extracted by mini-css-extract-plugin
module.exports = {"errorInfo":"errorInfo_errorInfo__vl2FP"};